import { ROUTES } from '@/constants/routes';
import { AppShell, Button, Container, Group, Image, Text } from '@mantine/core';
import { Link, useLocation } from 'react-router-dom';
import Breadcrumb from '../ui/Breadcrumb/Breadcrumb';
import UserMenu from './UserMenu';
import BreadcrumbProvider from '@/providers/BreadcrumbProvider';

export default function Layout({ children }: { children: React.ReactNode }) {
  const pathname = useLocation().pathname;

  const isAuthRoute = pathname === '/login';
  if (isAuthRoute)
    return (
      <Container fluid px="100px" py="lg">
        <Link to={ROUTES.HOME}>
          <Image src="/brand-logo-full.svg" maw="300px" mah="40px" />
        </Link>
        {children}
      </Container>
    );

  return (
    <AppShell header={{ height: 60 }} padding="md">
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between">
          <Group>
            <Link to={ROUTES.HOME}>
              <Image src="/brand-logo.svg" />
            </Link>
          </Group>

          <Group>
            {[
              { route: ROUTES.HOME, label: 'Home' },
              { route: ROUTES.DASHBOARD, label: 'RECORD-AI Dashboard' },
              { route: ROUTES.DOCUMENTS, label: 'Documents' },
              { route: ROUTES.RECORDS, label: 'Records' },
            ].map((item) => (
              <Button
                key={item.label}
                component={Link}
                to={item.route}
                variant="transparent"
                onClick={(e) => {
                  if (pathname === item.route) {
                    e.preventDefault();
                  }
                }}
              >
                <Text
                  variant={pathname === item.route ? 'semibold16' : 'regular16'}
                >
                  {item.label}
                </Text>
              </Button>
            ))}
          </Group>

          <Group>
            <UserMenu />
          </Group>
        </Group>
      </AppShell.Header>

      <AppShell.Main>
        <BreadcrumbProvider>
          <Breadcrumb />
          {children}
        </BreadcrumbProvider>
      </AppShell.Main>
    </AppShell>
  );
}
